import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconBookRead = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M8.668 8h4.667v1H8.668V8zm0-1.666h4.667v1H8.668v-1zm0 3.333h4.667v1H8.668v-1zm5.333-7h-12c-.733 0-1.333.6-1.333 1.333v8.667c0 .733.6 1.333 1.333 1.333h12c.734 0 1.334-.6 1.334-1.333V4c0-.733-.6-1.333-1.334-1.333zm0 10h-6V4h6v8.667z"
	})
});
export default SvgIconBookRead;
